module.exports = "/assets/data/1d73578109067963962af537e816f65c-IV36.data.json";